const config = {
  env: "local",
  // apiUrl: "http://192.168.0.78:5300/api/",
   apiUrl: "https://api.theastrostars.com/api/",
  //  apiUrl: "http://192.168.0.75:5300/api/",
};

export default config;